import { IconActionShareIOS24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ShareButton.css';

export interface IShareButtonProps {
  onClick(): void;
}

export function ShareButton({ onClick }: IShareButtonProps) {
  return (
    <button type="button" onClick={onClick} className={styles['button']}>
      <IconActionShareIOS24 />
    </button>
  );
}
